<template>
    <div>
        <!-- Sidebar backdrop (mobile only) -->
        <div class="fixed inset-0 bg-gray-900 bg-opacity-30 z-40 lg:hidden lg:z-auto transition-opacity duration-200"
             :class="sidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'" aria-hidden="true"></div>

        <!-- Sidebar -->
        <div
            id="sidebar"
            ref="sidebar"
            class="flex flex-col absolute z-40 left-0 top-0 lg:static lg:left-auto lg:top-auto lg:translate-x-0 transform h-screen overflow-y-scroll lg:overflow-y-auto no-scrollbar w-64 lg:w-20 lg:sidebar-expanded:!w-64 2xl:!w-64 shrink-0 bg-gray-800 p-4 transition-all duration-200 ease-in-out"
            :class="sidebarOpen ? 'translate-x-0' : '-translate-x-64'"
        >

            <!-- Sidebar header -->
            <div class="flex justify-between mb-10 pr-3 sm:px-2">
                <!-- Close button -->
                <button
                    ref="trigger"
                    class="lg:hidden text-gray-500 hover:text-gray-400"
                    @click.stop="$emit('close-sidebar')"
                    aria-controls="sidebar"
                    :aria-expanded="sidebarOpen"
                >
                    <span class="sr-only">Close sidebar</span>
                    <svg class="w-5 h-5 fill-current" viewBox="0 0 24 24">
                        <path d="M10.7 18.7l1.4-1.4L7.8 13H20v-2H7.8l4.3-4.3-1.4-1.4L4 12z"/>
                    </svg>
                </button>
                <!-- Logo -->
                <a href="/" target="_blank">
                  <img class="hidden xl:block w-60" src="/assets/img/logo_white.png">
                  <img class="block xl:hidden w-10" src="/assets/img/icon.png">
                </a>
            </div>

            <!-- Links -->
            <div v-if="$page.props.acl.isAdmin || $page.props.acl.isCommercial">
                <ul>
                    <li class="px-3 py-1 rounded-sm" :class="route().current('dashboard') && 'bg-gray-900'">
                        <Link :href="route('dashboard')"
                            class="block text-gray-200 hover:text-sky truncate transition duration-150"
                            :class="route().current('dashboard') && 'text-sky hover:text-sky-300 font-semibold'"
                        >
                            <div class="flex items-center">
                                <svg class="shrink-0 h-5 w-5" viewBox="0 0 24 24">
                                    <path class="fill-current text-gray-400"
                                            :class="route().current('dashboard') && 'text-sky-300'"
                                            d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0z"/>
                                    <path class="fill-current text-gray-600"
                                            :class="route().current('dashboard') && 'text-sky-dark'"
                                            d="M12 3c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9z"/>
                                    <path class="fill-current text-gray-400"
                                            :class="route().current('dashboard') && 'text-sky'"
                                            d="M12 15c-1.654 0-3-1.346-3-3 0-.462.113-.894.3-1.285L6 6l4.714 3.301A2.973 2.973 0 0112 9c1.654 0 3 1.346 3 3s-1.346 3-3 3z"/>
                                </svg>
                                <span class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Tableau de bord
                                </span>
                            </div>
                        </Link>
                    </li>
                </ul>
            </div>

            <hr v-if="$page.props.acl.isAdmin || $page.props.acl.isCommercial" class="my-4">

            <div class="space-y-2">
                <h3 class="text-xs uppercase text-gray-500 font-semibold pl-3">
                    <span class="hidden lg:block lg:sidebar-expanded:hidden 2xl:hidden text-center w-6"
                            aria-hidden="true">•••</span>
                    <span class="lg:hidden lg:sidebar-expanded:block 2xl:block">Gestion des colis & articles</span>
                </h3>
                <ul class="my-2">
                    <li class="px-3 py-1 rounded-sm mb-1 last:mb-0" :class="route().current('travels.*') && 'bg-gray-900'">
                        <Link :href="route('travels.index')" class="block text-gray-200 hover:text-sky truncate transition duration-150"
                            :class="route().current('travels.*') && 'text-sky hover:text-sky-300 font-semibold'"
                        >
                            <div class="flex items-center">
                                <svg class="shrink-0 h-5 w-5" viewBox="0 0 24 24">
                                    <path class="fill-current text-gray-400"
                                    :class="route().current('travels.*') && 'text-sky-300'"
                                        d="M13 15l11-7L11.504.136a1 1 0 00-1.019.007L0 7l13 8z"/>
                                    <path class="fill-current text-gray-600"
                                    :class="route().current('travels.*') && 'text-sky-dark'"
                                        d="M13 15L0 7v9c0 .355.189.685.496.864L13 24v-9z"/>
                                    <path class="fill-current text-gray-400"
                                    :class="route().current('travels.*') && 'text-sky'"
                                        d="M13 15.047V24l10.573-7.181A.999.999 0 0024 16V8l-11 7.047z"/>
                                </svg>
                                <span class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Expéditions
                                </span>
                            </div>
                        </Link>
                    </li>
                    <li class="px-3 py-1 rounded-sm mb-1 last:mb-0" :class="route().current('items.*') && 'bg-gray-900'">
                        <Link :href="route('items.index')" class="block text-gray-200 hover:text-primaryOrange truncate transition duration-150"
                            :class="route().current('items.*') && 'text-primaryOrange hover:text-primaryOrange-300 font-semibold'"
                        >
                            <div class="flex items-center">
                                <svg class="shrink-0 h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                    <path fill-rule="evenodd" d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z" clip-rule="evenodd"></path></svg>
                                <span class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    La Boutique
                                </span>
                            </div>
                        </Link>
                    </li>
                </ul>
            </div>

            <hr v-if="$page.props.acl.isAdmin" class="my-4">

            <div v-if="$page.props.acl.isAdmin" class="space-y-2">
                <h3 class="text-xs uppercase text-gray-500 font-semibold pl-3">
                    <span class="hidden lg:block lg:sidebar-expanded:hidden 2xl:hidden text-center w-6"
                            aria-hidden="true">•••</span>
                    <span class="lg:hidden lg:sidebar-expanded:block 2xl:block">Gestion des clients</span>
                </h3>
                <ul class="my-2">
                    <li class="px-3 py-1 rounded-sm mb-1 last:mb-0" :class="route().current('customers.*') && 'bg-gray-900'">
                        <Link :href="route('customers.index')" class="block text-gray-200 hover:text-sky truncate transition duration-150"
                            :class="route().current('customers.*') && 'text-sky hover:text-sky-300 font-semibold'"
                        >
                            <div class="flex items-center">
                                <svg class="shrink-0 h-5 w-5" viewBox="0 0 24 24">
                                    <path class="fill-current text-gray-600" :class="route().current('customers.*') && 'text-sky-300'"
                                        d="M18.974 8H22a2 2 0 012 2v6h-2v5a1 1 0 01-1 1h-2a1 1 0 01-1-1v-5h-2v-6a2 2 0 012-2h.974zM20 7a2 2 0 11-.001-3.999A2 2 0 0120 7zM2.974 8H6a2 2 0 012 2v6H6v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5H0v-6a2 2 0 012-2h.974zM4 7a2 2 0 11-.001-3.999A2 2 0 014 7z"></path>
                                    <path class="fill-current text-gray-400"
                                        d="M12 6a3 3 0 110-6 3 3 0 010 6zm2 18h-4a1 1 0 01-1-1v-6H6v-6a3 3 0 013-3h6a3 3 0 013 3v6h-3v6a1 1 0 01-1 1z">
                                    </path>
                                </svg>
                                <span class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Clients
                                </span>
                            </div>
                        </Link>
                    </li>
                </ul>
            </div>

            <hr class="my-4" v-if="$page.props.acl.isAdmin || $page.props.acl.isCommercial">

            <div class="space-y-2" v-if="$page.props.acl.isAdmin || $page.props.acl.isCommercial">
                <h3 class="text-xs uppercase text-gray-500 font-semibold pl-3">
                    <span class="hidden lg:block lg:sidebar-expanded:hidden 2xl:hidden text-center w-6"
                            aria-hidden="true">•••</span>
                    <span class="lg:hidden lg:sidebar-expanded:block 2xl:block">Gestion des demandes</span>
                </h3>
                <ul class="my-2">
                    <li class="px-3 py-1 rounded-sm mb-1 last:mb-0" :class="route().current('requests.*') && 'bg-gray-900'">
                        <Link :href="route('requests.index')" class="block text-gray-200 hover:text-sky truncate transition duration-150"
                            :class="route().current('requests.*') && 'text-sky hover:text-sky-300 font-semibold'"
                        >
                            <div class="flex items-center">
                                <svg class="shrink-0 h-5 w-5" viewBox="0 0 24 24">
                                    <path class="fill-current text-gray-600" :class="route().current('requests.*') && 'text-sky-dark'" d="M14.5 7c4.695 0 8.5 3.184 8.5 7.111 0 1.597-.638 3.067-1.7 4.253V23l-4.108-2.148a10 10 0 01-2.692.37c-4.695 0-8.5-3.184-8.5-7.11C6 10.183 9.805 7 14.5 7z"></path>
                                    <path class="fill-current text-gray-400" :class="route().current('requests.*') && 'text-sky-300'" d="M11 1C5.477 1 1 4.582 1 9c0 1.797.75 3.45 2 4.785V19l4.833-2.416C8.829 16.85 9.892 17 11 17c5.523 0 10-3.582 10-8s-4.477-8-10-8z"></path>
                                </svg>
                                <span class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Demandes
                                </span>
                            </div>
                        </Link>
                    </li>
                </ul>
            </div>

            <hr class="my-4" v-if="$page.props.acl.isAdmin">

            <div class="space-y-2" v-if="$page.props.acl.isAdmin">
                <h3 class="text-xs uppercase text-gray-500 font-semibold pl-3">
                    <span class="hidden lg:block lg:sidebar-expanded:hidden 2xl:hidden text-center w-6"
                            aria-hidden="true">•••</span>
                    <span class="lg:hidden lg:sidebar-expanded:block 2xl:block">Configuration</span>
                </h3>
                <ul class="my-2">
                    <li class="px-3 py-1 rounded-sm mb-1 last:mb-0"
                        :class="route().current('warehouses.index') && 'bg-gray-900'">
                        <Link :href="route('warehouses.index')"
                            class="block text-gray-200 hover:text-sky truncate transition duration-150"
                            :class="route().current('warehouses.*') && 'text-sky hover:text-sky-300 font-semibold'"
                        >
                            <div class="flex items-center">
                                <svg class="w-5 h-5 fill-current shrink-0 mr-1" viewBox="0 0 16 16">
                                    <path d="M8 8.992a2 2 0 1 1-.002-3.998A2 2 0 0 1 8 8.992Zm-.7 6.694c-.1-.1-4.2-3.696-4.2-3.796C1.7 10.69 1 8.892 1 6.994 1 3.097 4.1 0 8 0s7 3.097 7 6.994c0 1.898-.7 3.697-2.1 4.996-.1.1-4.1 3.696-4.2 3.796-.4.3-1 .3-1.4-.1Zm-2.7-4.995L8 13.688l3.4-2.997c1-1 1.6-2.198 1.6-3.597 0-2.798-2.2-4.996-5-4.996S3 4.196 3 6.994c0 1.399.6 2.698 1.6 3.697 0-.1 0-.1 0 0Z">
                                    </path>
                                </svg>
                                <span class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Entrepôts
                                </span>
                            </div>
                        </Link>
                    </li>
                    <li class="px-3 py-1 rounded-sm mb-1 last:mb-0"
                        :class="route().current('categories.index') && 'bg-gray-900'">
                        <Link :href="route('categories.index')"
                            class="block text-gray-200 hover:text-sky truncate transition duration-150"
                            :class="route().current('categories.*') && 'text-sky hover:text-sky-300 font-semibold'"
                        >
                            <div class="flex items-center">
                                <svg class="w-5 h-5 fill-current shrink-0 mr-1" viewBox="0 0 24 24">
                                    <path d="M3 3h8v8H3V3zm10 0h8v8h-8V3zM3 13h8v8H3v-8zm10 0h8v8h-8v-8z"/>
                                </svg>
                                <span class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Catégories
                                </span>
                            </div>
                        </Link>
                    </li>
                    <li class="px-3 py-1 rounded-sm mb-1 last:mb-0" :class="route().current('users.*') && 'bg-gray-900'">
                        <Link :href="route('users.index')" class="block text-gray-200 hover:text-sky truncate transition duration-150"
                            :class="route().current('users.*') && 'text-sky hover:text-sky-300 font-semibold'"
                        >
                            <div class="flex items-center">
                                <i class="fad fa-users-cog text-xl" :class="route().current('users.*') && 'text-sky-300'"></i>
                                <span class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Utilisateurs
                                </span>
                            </div>
                        </Link>
                    </li>
                    <li class="px-3 py-1 rounded-sm mb-1 last:mb-0" :class="route().current('settings.*') && 'bg-gray-900'">
                        <Link :href="route('settings.general')" class="block text-gray-200 hover:text-sky truncate transition duration-150"
                            :class="route().current('settings.*') && 'text-sky hover:text-sky-300 font-semibold'"
                        >
                            <div class="flex items-center">
                                <svg class="shrink-0 h-5 w-5" viewBox="0 0 24 24">
                                    <path class="fill-current text-gray-600"
                                            :class="route().current('settings.*') && 'text-sky-300'" d="M19.714 14.7l-7.007 7.007-1.414-1.414 7.007-7.007c-.195-.4-.298-.84-.3-1.286a3 3 0 113 3 2.969 2.969 0 01-1.286-.3z"></path>
                                    <path class="fill-current text-gray-400"
                                            :class="route().current('settings.*') && 'text-sky-dark'" d="M10.714 18.3c.4-.195.84-.298 1.286-.3a3 3 0 11-3 3c.002-.446.105-.885.3-1.286l-6.007-6.007 1.414-1.414 6.007 6.007z"></path>
                                    <path class="fill-current text-gray-600"
                                            :class="route().current('settings.*') && 'text-sky-dark'" d="M5.7 10.714c.195.4.298.84.3 1.286a3 3 0 11-3-3c.446.002.885.105 1.286.3l7.007-7.007 1.414 1.414L5.7 10.714z"></path>
                                    <path class="fill-current text-gray-400"
                                            :class="route().current('settings.*') && 'text-sky'" d="M19.707 9.292a3.012 3.012 0 00-1.415 1.415L13.286 5.7c-.4.195-.84.298-1.286.3a3 3 0 113-3 2.969 2.969 0 01-.3 1.286l5.007 5.006z"></path>
                                </svg>
                                <span class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Paramètres
                                </span>
                            </div>
                        </Link>
                    </li>
                </ul>
            </div>
            
            <hr class="my-4" v-if="$page.props.acl.isAdmin">

            <div class="space-y-2" v-if="$page.props.acl.isAdmin">
                <h3 class="text-xs uppercase text-gray-500 font-semibold pl-3">
                    <span class="hidden lg:block lg:sidebar-expanded:hidden 2xl:hidden text-center w-6"
                            aria-hidden="true">•••</span>
                    <span class="lg:hidden lg:sidebar-expanded:block 2xl:block">Application</span>
                </h3>
                <ul class="my-2">
                    <li class="px-3 py-1 rounded-sm mb-1 last:mb-0" :class="route().current('app-messages.index') && 'bg-gray-900'">
                        <Link :href="route('app-messages.index')"
                            class="block text-gray-200 hover:text-sky truncate transition duration-150"
                           :class="{
                                    'text-sky hover:text-sky-300 font-semibold':
                                        route().current('app-messages.index') ||
                                        route().current('app-messages.create')
                                }"
                        >
                            <div class="flex items-center">
                                <svg class="w-5 h-5 fill-current shrink-0 mr-1" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M20 2H4C2.9 2 2 2.9 2 4v12c0 1.1.9 2 2 2h3v4l5-4h8c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm0 14H11.3L9 17.8V16H4V4h16v12ZM6 7h12v2H6V7Zm0 4h8v2H6v-2Z"
                                    />
                                </svg>
                                <span class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Messages application
                                </span>
                            </div>
                        </Link>
                    </li>
                    <li class="px-3 py-1 rounded-sm mb-1 last:mb-0" :class="route().current('app-messages.statistics') && 'bg-gray-900'">
                        <Link :href="route('app-messages.statistics')"
                            class="block text-gray-200 hover:text-sky truncate transition duration-150"
                            :class="route().current('app-messages.statistics') && 'text-sky hover:text-sky-300 font-semibold'"
                        >
                            <div class="flex items-center">
                                <svg class="w-5 h-5 fill-current shrink-0 mr-1" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M5 20h14v2H3V2h2v18Zm3-2H6v-7h2v7Zm5 0h-2V6h2v12Zm5 0h-2V3h2v15Z" />
                                </svg>
                                <span class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Statistiques messages
                                </span>
                            </div>
                        </Link>
                    </li>
                    <li class="px-3 py-1 rounded-sm mb-1 last:mb-0" :class="route().current('app-versions.*') && 'bg-gray-900'">
                        <Link :href="route('app-versions.index')"
                            class="block text-gray-200 hover:text-sky truncate transition duration-150"
                            :class="route().current('app-versions.*') && 'text-sky hover:text-sky-300 font-semibold'"
                        >
                            <div class="flex items-center">
                                <svg class="w-5 h-5 fill-current shrink-0 mr-1" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M17 1.01 7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99ZM17 19H7V5h10v14Z" />
                                </svg>
                                <span class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Versions app
                                </span>
                            </div>
                        </Link>
                    </li>
                    <li class="px-3 py-1 rounded-sm mb-1 last:mb-0">
                        <a href="/log-viewer"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="block text-gray-200 hover:text-sky truncate transition duration-150"
                        >
                            <div class="flex items-center">
                                <svg class="w-5 h-5 fill-current shrink-0 mr-1" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M4 4h16v2H4V4Zm0 4h16v2H4V8Zm0 4h10v2H4v-2Zm0 4h16v2H4v-2Zm0 4h12v2H4v-2Z" />
                                </svg>
                                <span class="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
                                    Logs Laravel
                                </span>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>

            <!-- Expand / collapse button -->
            <div class="p-3 hidden lg:inline-flex 2xl:hidden justify-end mt-auto">
                <button @click.prevent="sidebarExpanded = !sidebarExpanded">
                    <span class="sr-only">Expand / collapse sidebar</span>
                    <svg class="w-5 h-5 fill-current sidebar-expanded:rotate-180" viewBox="0 0 24 24">
                        <path class="text-gray-400" d="M19.586 11l-5-5L16 4.586 23.414 12 16 19.414 14.586 18l5-5H7v-2z"/>
                        <path class="text-gray-600" d="M3 23H1V1h2z"/>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { Link } from '@inertiajs/inertia-vue3';
    import SideBarLinkGroup from '@/Components/SidebarLinkGroup';
    import { defineComponent, ref, onMounted, onUnmounted, watch } from 'vue'

    export default defineComponent({
        props: {
            sidebar: Object,
            sidebarOpen: Boolean
        },

        components: {
            Link,
            SideBarLinkGroup
        },

        setup(props, {emit}) {
            const trigger = ref(null)
            const sidebar = ref(null)
            const storedSidebarExpanded = localStorage.getItem('sidebar-expanded')
            const sidebarExpanded = ref(storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true')

            // close on click outside
            const clickHandler = ({target}) => {
                if (!sidebar.value || !trigger.value) return
                if (
                    !props.sidebarOpen ||
                    sidebar.value.contains(target) ||
                    trigger.value.contains(target)
                ) return
                emit('close-sidebar')
            }
            // close if the esc key is pressed
            const keyHandler = ({keyCode}) => {
                if (!props.sidebarOpen || keyCode !== 27) return
                emit('close-sidebar')
            }
            onMounted(() => {
                document.addEventListener('click', clickHandler)
                document.addEventListener('keydown', keyHandler)
            })
            onUnmounted(() => {
                document.removeEventListener('click', clickHandler)
                document.removeEventListener('keydown', keyHandler)
            })
            watch(sidebarExpanded, () => {
                localStorage.setItem('sidebar-expanded', sidebarExpanded.value)
                if (sidebarExpanded.value) {
                    document.querySelector('body').classList.add('sidebar-expanded')
                } else {
                    document.querySelector('body').classList.remove('sidebar-expanded')
                }
            })
            return {
                trigger,
                sidebar,
                sidebarExpanded
            }
        },
    })
</script>
